import { FormInputNumber } from "../../../../../../components/ui/Input/FormInputNumber/FormInputNumber";
import { FormUnitInput } from "../../../../../../components/ui/Input/FormUnitInput/FormUnitInput";
import { WEIGHT_UNIT_TYPES_OPTIONs } from "../../../../../../config/constants";
import {
  isCheckPercentageIrrigation,
  validateExternalStorageName,
  valueGraterThanZero
} from "../../../../../../utils/utils";
import { ExternalStorageSectionProps, ExternalStorageVariantFeatures } from "../externalStorage.types";

interface ExternalStorageMetricsSectionProps extends ExternalStorageSectionProps {
  variantConfig: ExternalStorageVariantFeatures;
  isDefaultDataType: boolean;
}

const ExternalStorageMetricsSection = ({
  control,
  disabled,
  variantConfig,
  isDefaultDataType
}: ExternalStorageMetricsSectionProps) => (
  <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-4">
    <FormInputNumber
      control={control}
      name="storageTemperature"
      label="Storage Temperature (℃)"
      placeholder="Storage Temperature (℃)"
      disabled={disabled}
      enableMinus
      enableDecimalWithMinus
      rules={{
        validate: {
          valueCheck: (value: unknown) => validateExternalStorageName(value, true) || true
        }
      }}
    />

    {isDefaultDataType && (
      <FormInputNumber
        control={control}
        name="warehouseSize"
        label="Warehouse size (m3)"
        placeholder="Warehouse size (m3)"
        disabled={disabled}
        rules={{
          validate: {
            valueCheck: (value: unknown) => validateExternalStorageName(value) || true
          }
        }}
      />
    )}

    {variantConfig.supportsWeightUnit ? (
      <FormUnitInput
        control={control}
        name="weight"
        unitName="weightUnit"
        label="Weight"
        placeholder="0"
        required
        disabled={disabled}
        errorMessage="Weight is required"
        unitOptions={WEIGHT_UNIT_TYPES_OPTIONs}
        unitRequired
        validate={{
          decimalValidation: (value: unknown) => validateExternalStorageName(value) || true,
          valueCheck: (value: unknown) =>
            valueGraterThanZero(value) || "Weight must be greater than zero"
        }}
      />
    ) : (
      <FormInputNumber
        control={control}
        name="weight"
        label="Weight (kg)"
        placeholder="Weight (kg)"
        required
        disabled={disabled}
        errorMessage="Weight is required"
      />
    )}

    {isDefaultDataType && (
      <>
        <FormInputNumber
          control={control}
          name="electricity"
          label="Electricity (kWh)"
          placeholder="0"
          required
          disabled={disabled}
          errorMessage="Electricity is required"
          rules={{
            validate: {
              decimalValidation: (value: unknown) => validateExternalStorageName(value) || true,
              valueCheck: (value: unknown) =>
                valueGraterThanZero(value) || "Electricity must be greater than zero"
            }
          }}
        />
        <FormInputNumber
          control={control}
          name="warehouseUtilization"
          label="Utilization of warehouse %"
          placeholder="Utilization of warehouse %"
          required={isDefaultDataType}
          disabled={disabled || !isDefaultDataType}
          errorMessage="Utilization is required"
          rules={{
            validate: {
              valueCheck: (value: unknown) =>
                isDefaultDataType
                  ? isCheckPercentageIrrigation(value) ||
                    "Utilization must be less than or equal to 100"
                  : true
            }
          }}
        />
      </>
    )}

    <FormInputNumber
      control={control}
      name="storageDays"
      label="Storage day(s)"
      placeholder="Storage day(s)"
      required
      disabled={disabled}
      removeDecimal
      errorMessage="Storage days is required"
      rules={{
        validate: {
          valueCheck: (value: unknown) =>
            valueGraterThanZero(value) || "Storage days must be greater than zero",
          decimalValidation: (value: unknown) => validateExternalStorageName(value) || true
        }
      }}
    />
  </div>
);

export default ExternalStorageMetricsSection;
